module.exports = __webpack_public_path__ + "static/media/france.3be50381.svg";